import React, { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { setMode } from "../state/action";
import "../css/style.css";

const DayNightMode = props => {
  const night = useSelector(state => state.night, shallowEqual);
  const dispatch = useDispatch();
  useEffect(_=>{
    const localMode = localStorage.getItem('night');
    if(localMode){
      dispatch(setMode(localMode === 'true'))
    }
  },[])
  useEffect(
    _ => {
      localStorage.setItem('night',night);
      document.body.className = night ? "dark" : "light";
    },
    [night]
  );

  return (
    <a
      style={{ float: "right" }}
      onClick={e => dispatch(setMode(!night))}
      href="#"
      title={night ? "light mode" : "dark mode"}
    >
      {night ? (
        <i className="icon-wb_sunny" />
      ) : (
        <i className="icon-nights_stay" />
      )}
    </a>
  );
};

export default DayNightMode;
